import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { useEffect, useRef } from 'react';

interface LetterContentProps {
    body: string;
}

const LetterContent = ({ body }: LetterContentProps) => {
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (contentRef.current && body) {
            // Configure marked options
            marked.setOptions({
                breaks: true,
                gfm: true,
            });

            // Convert markdown to HTML
            const rawHtml = marked(body);

            // Sanitize HTML
            const cleanHtml = DOMPurify.sanitize(rawHtml as string, {
                ALLOWED_TAGS: [
                    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
                    'p', 'br', 'strong', 'em', 'u', 'a',
                    'ul', 'ol', 'li', 'blockquote', 'code', 'pre',
                    'img', 'hr', 'div', 'span', 'iframe', 'video', 'source'
                ],
                ALLOWED_ATTR: [
                    'href', 'src', 'alt', 'title', 'width', 'height',
                    'target', 'rel', 'class', 'frameborder', 'allowfullscreen',
                    'allow', 'style', 'controls', 'autoplay', 'loop', 'muted',
                    'type', 'poster'
                ],
            });

            // Set HTML content
            contentRef.current.innerHTML = cleanHtml;
        }
    }, [body]);

    return (
        <div
            ref={contentRef}
            className="letter-body prose prose-lg max-w-none"
        />
    );
};

export default LetterContent;
